import { useSelector } from 'react-redux'
import type { State, LoginProgressState } from '../types'

export const useLoginProgress = (): LoginProgressState => {
  const loginProgress = useSelector((state: State) => state.loginProgress)
  return loginProgress
}
